/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_OrInputs */

const en_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const de_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder`)
};

const fr_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

const es_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o`)
};

const it_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o`)
};

const nl_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of`)
};

const pl_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lub`)
};

const fi_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tai`)
};

const da_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eller`)
};

const sv_common_or = /** @type {(inputs: Common_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eller`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Common_OrInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_or = /** @type {((inputs?: Common_OrInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_OrInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_or(inputs)
	if (locale === "fr") return fr_common_or(inputs)
	if (locale === "es") return es_common_or(inputs)
	if (locale === "it") return it_common_or(inputs)
	if (locale === "nl") return nl_common_or(inputs)
	if (locale === "pl") return pl_common_or(inputs)
	if (locale === "fi") return fi_common_or(inputs)
	if (locale === "da") return da_common_or(inputs)
	if (locale === "sv") return sv_common_or(inputs)
	return en_common_or(inputs)
});